import { isYounger64 as isYounger64Utils } from "@/utils/validateField/dob";
import { useQuizContext } from "@/pages/quiz/context";

export const useGetIsYounger64 = () => {
  const { answers } = useQuizContext();

  const customDobAnswer = Object.values(answers).find(
    (a) => a?.blockName === "custom-dob"
  ) as { value: Record<string, string> };

  const isYounger64 = customDobAnswer
    ? isYounger64Utils(customDobAnswer?.value?.dob ?? "")
    : false;

  return isYounger64;
};
